import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Avatar from 'flarum/common/components/Avatar';
import HeaderListItem from 'flarum/forum/components/HeaderListItem';
import { messagePreview } from '../../common/utils/preview';
import { authorName } from './bot';

/**
 * Coloca as denúncias do chat na lista do flarum/flags. No banco não dá:
 * `flags.post_id` é FK não nula para `posts`, e alterar o schema da extensão seria
 * desfeito na próxima versão. Compartilha-se a interface: o dropdown e a página
 * /flags renderizam `FlagList`.
 *
 * Sem o flarum/flags nada disto roda; a fila própria em /chat/flags não depende dele.
 */

/** Carregado uma vez por página e mantido entre redesenhos. */
let reports = [];
let loaded = false;
let loading = false;

/**
 * Resolve um módulo de outra extensão sem importá-lo. Um `import` direto seria
 * dependência obrigatória e quebraria o bundle sem o flarum/flags; `checkModule`
 * só responde false.
 */
function moduleOf(path) {
  var _window;
  const registry = (_window = window) == null || (_window = _window.flarum) == null ? void 0 : _window.reg;
  if (!registry) return null;
  try {
    var _registry$get, _found$default;
    const found = typeof registry.checkModule === 'function' ? registry.checkModule('flarum-flags', path) : (_registry$get = registry.get) == null ? void 0 : _registry$get.call(registry, 'flarum-flags', path);

    // O registro devolve o namespace do módulo; o componente é o export padrão.
    return found ? (_found$default = found.default) != null ? _found$default : found : null;
  } catch (_unused) {
    return null;
  }
}
function load() {
  if (loaded || loading) return;
  loading = true;
  app.store.find('chat-message-flags', {
    filter: {
      resolved: '0'
    },
    sort: '-createdAt',
    page: {
      limit: 20
    }
  }).then(results => {
    reports = Array.isArray(results) ? results : [];
  }).catch(() => {
    // Fórum sem a fila do chat, ou moderador que perdeu a permissão na sessão; a
    // lista de flags continua útil sem isto.
    reports = [];
  }).finally(() => {
    loading = false;
    loaded = true;
    m.redraw();
  });
}

/**
 * Uma denúncia, desenhada como o flarum/flags desenha um post denunciado. Sem key
 * de propósito: as linhas do flarum/flags não têm key, e o Mithril recusa um
 * fragmento que mistura filhos com e sem key, o que derrubaria o dropdown inteiro.
 */
function row(report) {
  var _displayName, _ref;
  const message = report.message();
  if (!message) return null;
  return m("li", null, m(HeaderListItem, {
    className: "Flag Flag--chat",
    avatar: m(Avatar, {
      user: message.user() || null
    }),
    icon: "fas fa-comment-dots",
    content: app.translator.trans('ramon-chat.forum.flags.flarum_item', {
      username: authorName(message),
      em: m("em", null),
      channel: (_displayName = (_ref = message.channel() || null) == null ? void 0 : _ref.displayName()) != null ? _displayName : '',
      reason: app.translator.trans("ramon-chat.forum.flag.reasons.".concat(report.reason()), {}, true)
    }),
    excerpt: messagePreview(message, 120),
    datetime: report.createdAt(),
    href: app.route('chat.flags'),
    onclick: e => {
      e.redraw = false;
    }
  }));
}
export default function bindFlagsIntegration() {
  const FlagList = moduleOf('forum/components/FlagList');
  const FlagsDropdown = moduleOf('forum/components/FlagsDropdown');
  if (!(FlagList != null && FlagList.prototype)) return;

  // Busca ao montar a lista, não no boot: quem nunca abre o dropdown não paga o request.
  extend(FlagList.prototype, 'oninit', function () {
    if (app.forum.attribute('canModerateChat')) load();
  });

  // `override`, não `extend`: extend() descarta o retorno do callback, e
  // `content()` devolve um array novo ou null.
  override(FlagList.prototype, 'content', function (original, state) {
    const vdom = original(state);
    if (!app.forum.attribute('canModerateChat')) return vdom;
    const rows = reports.map(row).filter(Boolean);
    if (rows.length === 0) return vdom;

    // Anexado no fim, não intercalado por data: o flarum/flags pagina a própria
    // lista e carregaria posts por cima.
    return vdom === null ? rows : [vdom, rows];
  });

  // O badge do header conta os dois, para acender só com denúncias do chat. É um
  // número, então `extend` não o alcança.
  if (FlagsDropdown != null && FlagsDropdown.prototype) {
    override(FlagsDropdown.prototype, 'getUnreadCount', function (original) {
      var _original, _app$forum$attribute;
      const own = Number((_original = original()) != null ? _original : 0);
      const chat = Number((_app$forum$attribute = app.forum.attribute('chatOpenFlagsCount')) != null ? _app$forum$attribute : 0);
      return own + chat;
    });
  }
}
flarum.reg.add('ramon-chat', 'forum/utils/flagsIntegration', bindFlagsIntegration);